/// <reference types="gapi.youtube" />
import _ from 'lodash';
const THUMBNAIL_SIZES = ['high', 'medium', 'standard', 'default'];
export function getThumbnail(thumbnails) {
    if (!thumbnails) {
        return undefined;
    }
    const biggestThumbByWidth = _(thumbnails).values().maxBy('width');
    const biggestAvailableSize = _(THUMBNAIL_SIZES)
        .takeWhile((size) => _.has(thumbnails, size))
        .head();
    const biggestThumbnail = biggestThumbByWidth || thumbnails[biggestAvailableSize];
    return biggestThumbnail?.url;
}
export default getThumbnail;
//# sourceMappingURL=get-thumbnail.js.map